import { useProjectUIStore } from "stores/projectStore";
import * as identify from "utils/treeUtils";
import cx from "classnames";
import { NodeTitle } from "components/ProjectTree/components/NodeTitle";
import { EditNodeTypes } from "components/ProjectTree/components/EditNodeTypes";
import { Icon } from "components/Icon/Icon";
import React from "react";

export const ProductDetails = ({
  options,
  productName,
  presentation,
  navigateToProduct,
  isPasteMode,
  isEditMode,
  setIsEditMode,
  handleUpdateProductName,
  handleToggleEditMode,
  navigateToCustomProduct,
  data,
}) => {
  const showProductPictures = useProjectUIStore(
    (state) => state.showProductPictures,
  );
  const onNavigateIconClick = () => {
    if (
      !isPasteMode &&
      !identify.isTroxNetcom(data) &&
      !identify.isCustomProduct(data)
    ) {
      navigateToProduct(data);
    }
    if (
      !isPasteMode &&
      (identify.isTroxNetcom(data) || identify.isCustomProduct(data))
    ) {
      navigateToCustomProduct(data);
    }
  };

  return (
    <div
      className={cx(
        "d-flex gap-2 flex-grow-1",
        showProductPictures && !options.productImagesDisabled
          ? "flex-column"
          : "flex-row justify-content-start",
      )}
      style={{ minWidth: 0 }}
    >
      <div className="d-flex flex-row align-items-center gap-2">
        <NodeTitle
          title={productName}
          isEditMode={
            isEditMode === EditNodeTypes.TITLE && !identify.isTroxNetcom(data)
          }
          setIsEditMode={setIsEditMode}
          handleToggleEditMode={handleToggleEditMode}
          isEditable={!identify.isWizard(data) && !options.editNodeDisabled}
          handleUpdateTitle={handleUpdateProductName}
          nodeId={data.id}
        />
        {!identify.isWizard(data) && !options.configurationLinkDisabled && (
          <Icon
            className={cx(
              "text-gray-300",
              isPasteMode ? "cursor-not-allowed" : "cursor-pointer",
            )}
            prefix="trox"
            data-testid="product-configurator-link-icon"
            iconName="arrow-up-right-square-regular"
            onClick={onNavigateIconClick}
          />
        )}
      </div>
      <span className="text-gray-400 text-truncate" style={{ minWidth: 0 }}>
        {presentation}
      </span>
    </div>
  );
};
